/* Custom announcement bar — countdown timer custom element */
(function () {
  if (customElements.get('countdown-bar')) return;

  class CountdownBar extends HTMLElement {
    constructor() {
      super();
      this._tick = this._tick.bind(this);
    }

    connectedCallback() {
      const mode = (this.dataset.mode || 'fixed').toLowerCase();

      if (mode === 'session') {
        this.target = this._sessionTarget();
      } else {
        this.target = this._parseTarget(this.dataset.target || '');
      }

      this.expiredText = this.dataset.expiredText || '';
      this.hideWhenExpired = this.dataset.hideWhenExpired === 'true';

      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      if (!this.target) {
        // No valid target — show 00s and don't start the timer.
        this._setAll(0, 0, 0, 0);
        return;
      }

      this._tick();
      this.timer = setInterval(this._tick, 1000);
    }

    _sessionTarget() {
      const durationMs = parseInt(this.dataset.durationMs, 10) || 0;
      if (durationMs <= 0) return null;

      const sectionId = this.dataset.sectionId || 'default';
      const storageKey = 'cab-start-' + sectionId;

      // sessionStorage persists across page loads within the same tab but
      // clears when the tab is closed. That gives the visitor a fresh
      // timer each new visit, while the timer survives refreshes during
      // the current session. (Lymphoria's pattern.)
      let startTime = NaN;
      try {
        startTime = parseInt(sessionStorage.getItem(storageKey), 10);
      } catch (e) {
        // Storage blocked (e.g. private mode). Fall through.
      }

      if (!startTime || isNaN(startTime)) {
        startTime = Date.now();
        try {
          sessionStorage.setItem(storageKey, String(startTime));
        } catch (e) {
          // Best effort; if storage is unavailable the timer just starts
          // fresh on every page load.
        }
      }

      return new Date(startTime + durationMs);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    _parseTarget(str) {
      if (!str) return null;
      // Accept "YYYY-MM-DD HH:MM:SS" by converting to ISO-ish.
      const normalized = str.includes('T') ? str : str.replace(' ', 'T');
      const d = new Date(normalized);
      return isNaN(d.getTime()) ? null : d;
    }

    _tick() {
      const now = new Date();
      const diff = this.target.getTime() - now.getTime();

      if (diff <= 0) {
        this._setAll(0, 0, 0, 0);
        this._showExpired();
        if (this.timer) clearInterval(this.timer);
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      // If days are hidden, fold the days into hours so the visible total is still correct.
      const visibleHours = this.daysEl ? hours : hours + days * 24;

      this._setAll(days, visibleHours, minutes, seconds);
    }

    _setAll(days, hours, minutes, seconds) {
      if (this.daysEl) this.daysEl.textContent = this._pad(days);
      if (this.hoursEl) this.hoursEl.textContent = this._pad(hours);
      if (this.minutesEl) this.minutesEl.textContent = this._pad(minutes);
      if (this.secondsEl) this.secondsEl.textContent = this._pad(seconds);
    }

    _pad(n) {
      return String(Math.max(0, n)).padStart(2, '0');
    }

    _showExpired() {
      const bar = this.closest('.custom-announcement-bar');

      if (this.hideWhenExpired && bar) {
        bar.classList.add('is-expired-hidden');
        return;
      }

      if (this.expiredText) {
        // Replace inner content with the expired text, keeping the link wrapper.
        const expiredSpan = document.createElement('span');
        expiredSpan.className = 'custom-announcement-bar__text';
        expiredSpan.textContent = this.expiredText;
        this.replaceChildren(expiredSpan);
      }
    }
  }

  customElements.define('countdown-bar', CountdownBar);
})();
